import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../order.service';
import { Store } from '../models/store';
import { OrdersWithPayment, Order, Modifier, BotOrder } from '../models/order';
import { EarnedReward, earnedRewardSummary } from '../models/earned-reward';
import * as moment from 'moment';
import { Constants } from '../constants';
import { OrderHelpers } from '../order-summary/utils/helpers';
import { ArrivedDialogComponent } from '../arrived-dialog/arrived-dialog.component';
import { OrderSocketService } from '../_services/order-socket.service';
import { StoreService } from '../_services/store.service';
import { IMqttMessage, IPublishOptions, MqttService } from "ngx-mqtt";
import { IClientSubscribeOptions } from "mqtt/types/lib/client-options";
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DeliveryTrackingService } from './delivery-tracking/delivery-tracking.service';
import { DeliveryTrack } from './delivery-tracking/delivery-tracking.models';


@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderStatusComponent implements OnInit, OnDestroy {

  tt;
  color = 'red';
  orderHash: string;
  status: string;
  orderWithPayment: OrdersWithPayment;
  store: Store;
  initial: string;
  displayedColumns: string[] = ['quantity', 'item', 'itemTotal'];
  pizzaOptions: Map<string, string> = Constants.pizzaOptions
  pizzaOptions$:Map<string, string> = Constants.pizzaOptionsFlag;
  estimatedTime: Date;

  curbsideConfirm = false;
  ends;
  submittedAt;
  uiSetting: any;
  isLoading = true;
  reorder = false;
  showReorder = false;
  isAdmin = false;
  spotData: any;
  errorMessages = {
    'Expired card': 'Expired Card: Sorry we could not process your order. The current card selected is Expired. Please change the payment type and resubmit your order.',
    'Decline': 'Decline: Sorry we could not process your order. The current card selected is being declined. Please change the payment type and resubmit your order.',
    'Invalid card': 'Invalid Card: Sorry we could not process your order. The current card selected is invalid. Please change the payment type and resubmit your order.',
    'Not sufficient funds': 'Insufficient Funds: Sorry we could not process your order. The current card selected has insufficient funds to make payments. Please change the payment type and resubmit your order.',
    'Invalid account number': 'Invalid Account Number: Sorry we could not process your order. The current card selected has an invalid card number. Please change the payment type and resubmit your order.',
    'Restricted card': 'Restricted Card: Sorry we could not process your order. The current card selected has a restricted card number. Please change the payment type and resubmit your order.',
    'Transaction not permitted to cardholder': 'Transaction not permitted the cardholder: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Service not allowed': 'Service Not Allowed: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid transaction': 'Invalid Transaction: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Wrong expiration': 'Wrong Expiration Date: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Timed out': 'Timed out: Sorry we could not process your order. Please click back, wait a couple of minutes, and resubmit your order.',
    'Do not honor': 'Do not honor: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Non-numeric expiry': 'Non-numeric expiry: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Declined': 'Decline: Sorry we could not process your order. The current card selected is being declined. Please change the payment type and resubmit your order.',
    'Invalid issuer': 'Invalid Issuer: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid amount': 'Invalid Amount: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Hierarchy validation': 'Hierarchy Validation: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'ADD AUTH REQUIRE': 'ADD AUTH REQUIRE: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid merchant': 'Invalid Merchant: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid Timezone': 'Please check our posted hours of operation and try again later. You are receiving this message because you may have your timezone settings on your device set to the incorrect timezone.',
    'Missing payment method': 'Sorry we could not process your order because the payment method could not be attached. Please select your payment method again and resubmit your order.',
    'DUPLICATE_REQUEST': 'Your payment may still be processing. Please wait a moment and check your order status before trying again. If the issue persists, contact the store directly.',
    'Unknown error': 'Sorry, we experienced a temporary issue processing your payment. Please wait a moment and try again.'
  }
  error;

  prgrsBar1: number;
  step1: string;
  c_color1: string;
  bar_color1: string;
  current_status1: boolean;

  prgrsBar2: number;
  step2: string;
  c_color2: string;
  bar_color2: string;
  current_status2: boolean;

  prgrsBar3: number;
  step3: string;
  c_color3: string;
  bar_color3: string;
  current_status3: boolean;
  mqtSub;
  statusinterval: any;
  reOrderItem: boolean;
  earnedRewards: EarnedReward[] = [];
  /** Delivery v2 live tracking (ENG-5514). Null means: show the classic progress bar. */
  deliveryTrack: DeliveryTrack | null = null;
  /** True while the first track request of a delivery order is still unanswered. */
  deliveryTrackPending = false;
  private deliveryTrackSub: Subscription;
  private destroySubject: Subject<void> = new Subject();
  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    public dialog: MatDialog,
    private router: Router,
    private orderSocketService: OrderSocketService,
    private storeService: StoreService,
    private mqttService: MqttService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private deliveryTracking: DeliveryTrackingService,
  ) { }

  ngOnInit() {
    this.orderHash = this.route.snapshot.paramMap.get('o_hash');
    this.isAdmin = this.route.snapshot.queryParamMap.get('is_admin') === '1';
    this.status = this.route.snapshot.paramMap.get('status');
    // this.subMqtt();

    this.orderService.getOrder(this.orderHash, "0").subscribe(
      data => {
        // Null safety check for API response
        if (!data || !data.store || !data.bot_order) {
          console.error('[ORDER_STATUS] Error: Invalid order data received', data);
          this.isLoading = false;
          this.error = 'Unable to load order details. Please try again later.';
          return;
        }

        this.orderWithPayment = Object.assign(new OrdersWithPayment(), data, {
          bot_order: Object.assign(new BotOrder(), data.bot_order, {
            occasion_schedule: moment(data.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
            created_at: moment(data.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
            updated_at: moment(data.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
            submitted_at: moment(data.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
          }),
          store: Object.assign(new Store(), data.store),
          items: data.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
          })),
          payment: OrderHelpers.parsePayment(data.payment)
        });

        // Additional null check before accessing nested properties
        if (!this.orderWithPayment || !this.orderWithPayment.store || !this.orderWithPayment.store.store_name) {
          console.error('[ORDER_STATUS] Error: orderWithPayment.store is null or undefined');
          this.isLoading = false;
          this.error = 'Unable to load store details. Please try again later.';
          return;
        }

        this.initial = this.orderWithPayment.store.store_name.split(" ").map(p => p[0]).join("")
        let failure = Object.keys(this.errorMessages).filter(m => this.orderWithPayment.bot_order.failure_reason.includes(m));
        if (failure.length <= 0) {
          this.error = `${this.orderWithPayment.bot_order.failure_reason}Sorry we could not process your order. Please update or change the payment type and resubmit your order.`
        } else {
          this.error = this.errorMessages[failure[0]];
        }
        console.log(this.error, failure);
        this.uiSetting = this.orderWithPayment.store.ui_settings;
        this.isLoading = false;
        this.orderWithPayment.items.forEach(item => this.reorder = this.reorder && item.menu_item.is_available)

        console.log('Order in success URL', this.orderWithPayment);
        this.storeService.changeStore(this.orderWithPayment.store);
        this.orderTrackingStatus(this.orderWithPayment);
        this.loadEarnedRewards();
        this.startDeliveryTracking();
        this.route.queryParams.pipe(takeUntil(this.destroySubject)).subscribe(params => {
          if ('reorder' in params) {
            this.showReorder = true
            if (params.reorder == 'true'){
              this.reorder = this.orderWithPayment.store.isEnabled('reorder')
              if (this.orderWithPayment.store.isEnabled('reorder')) {
                this.orderService.checkReorderMenuItem(this.orderWithPayment.bot_order.order_hash).subscribe((data:any) => {
                  this.reOrderItem = data.data;
                  this.reorder = data.data;
                  if (!this.reOrderItem) {
                    this.snackBar.open('Selected menu item or modifier is not available', "OK", {
                      verticalPosition: 'top'
                    })
                  }
                  this.cdr.markForCheck();
                });
              }
            }
            else{
              this.reorder = false;
            }
          }
        })
        this.cdr.markForCheck();

      },
    err => {
      console.error('[ORDER_STATUS] Error fetching order:', err);
      this.isLoading = false;
      this.error = 'Unable to load order details. Please try again later.';
    });

    if (this.status == "success") {
      this.statusinterval = setInterval(() => {
        this.getOrderStatus();
      }, 30000);
    }
  }

  goBack() {
    window.history.back()
  }

  loadEarnedRewards() {
    const userHash = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.encoded_id;
    const storeId = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.store;
    if (!userHash || !storeId || this.orderWithPayment.bot_order.is_cancelled) {
      return;
    }
    this.orderService.getMyRewards(String(storeId), userHash).subscribe({
      next: (data) => {
        this.earnedRewards = ((data && data.active) || []).filter(r =>
          r.status === 'ACTIVE' &&
          r.earned_from_order_hash === this.orderWithPayment.bot_order.order_hash);
        this.cdr.markForCheck();
      },
      error: () => { }
    });
  }

  getRewardSummary(reward: EarnedReward) {
    return earnedRewardSummary(reward);
  }

  /**
   * Live tracking for in-house delivery orders. Any other occasion never calls the
   * endpoint, and when it 404s or fails the page stays exactly as it was before.
   */
  private startDeliveryTracking() {
    const order = this.orderWithPayment && this.orderWithPayment.bot_order;
    if (this.deliveryTrackSub || this.status !== 'success' || !order) {
      return;
    }
    // Third-party couriers keep their own tracking inside <app-order-progress>.
    if (order.occasion !== 'DELIVERY' || order.is_cancelled || order.delivery_status_doordash) {
      return;
    }
    this.deliveryTrackPending = true;
    const settle = () => {
      if (this.deliveryTrackPending) {
        this.deliveryTrackPending = false;
        this.cdr.markForCheck();
      }
    };
    this.deliveryTrackSub = this.deliveryTracking.watch(this.orderHash)
      .pipe(takeUntil(this.destroySubject))
      .subscribe({
        next: track => {
          this.deliveryTrack = track;
          this.deliveryTrackPending = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.deliveryTrack = null;
          settle();
        },
        complete: settle
      });
  }

  informStore(): void {

    const dialogRef = this.dialog.open(ArrivedDialogComponent, {
      width: '350px',
      disableClose: true,
      data: {
        confirmText: 'I\'m here',
        message: 'Please make sure you are parked in a designated, legal, safe place.',
        parking: 1,
        spot_field: this.orderWithPayment.store.is_spot_field_mandatory
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      this.isLoading = true;
      if (data == true) {
        if (this.orderWithPayment.store.is_spot_field_mandatory) {
          this.spotData = dialogRef.componentInstance.form.get('name').value;
        } else {
          this.spotData = '';
        }
        this.orderService.curbsideConfirm(this.orderHash, this.spotData).subscribe(data => {
          this.orderWithPayment.bot_order.curbside_drop_off = true;
          this.isLoading = false;
        },
          (error) => {
            if (error.status == 400) {
              this.isLoading = false;
              this.orderWithPayment.bot_order.curbside_drop_off = true;
            }
          });
      } else {
        this.isLoading = false;
      }
    });
  }

  reOrder() {
    this.orderService.reOrder(this.orderHash).subscribe(response => {
      this.router.navigate(['order', response.order_hash])
    });
  }

  orderTrackingStatus(order) {
    if (order) {
      if (order.bot_order.is_cancelled) {
        this.prgrsBar1 = 100;
        this.step1 = 'Declined';
        this.c_color1 = 'red';
        this.bar_color1 = 'red';
        this.current_status1 = false;

        this.prgrsBar2 = 100;
        this.step2 = 'Preparing';
        this.c_color2 = 'grey';
        this.bar_color2 = 'grey';
        this.current_status2 = false;

        this.prgrsBar3 = 100;
        this.step3 = 'Ready!';
        this.c_color3 = 'grey';
        this.bar_color3 = 'grey';
        this.current_status3 = false;

        clearInterval(this.statusinterval);
      } else {
        if (!order.bot_order.view_notified && !order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Submitting';
          this.c_color1 = 'orange';
          this.bar_color1 = 'grey';
          this.current_status1 = true;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'grey';
          this.bar_color2 = 'grey';
          this.current_status2 = false;

          this.prgrsBar3 = 0;
          this.step3 = 'Ready!';
          this.c_color3 = 'grey';
          this.bar_color3 = 'grey';
          this.current_status3 = false;
        }
        else if (order.bot_order.view_notified && !order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Received';
          this.c_color1 = 'green';
          this.bar_color1 = 'green';
          this.current_status1 = false;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'orange';
          this.bar_color2 = 'grey';
          this.current_status2 = true;

          this.prgrsBar3 = 0;
          this.step3 = 'Ready!';
          this.c_color3 = 'grey';
          this.bar_color3 = 'grey';
          this.current_status3 = false;
        }
        else if (order.bot_order.view_notified && order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Received';
          this.c_color1 = 'green';
          this.bar_color1 = 'green';
          this.current_status1 = false;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'green';
          this.bar_color2 = 'green';
          this.current_status2 = false;

          this.prgrsBar3 = 100;
          this.step3 = 'Ready!';
          this.c_color3 = 'green';
          this.bar_color3 = 'green';
          this.current_status3 = false;

          clearInterval(this.statusinterval);
        }
      }
      this.tt = [
        {

          "percent": this.prgrsBar1,
          "name": this.step1,
          "color": this.c_color1,
          "bar_color": this.bar_color1,
          "current_status": this.current_status1
        },
        {

          "percent": this.prgrsBar2,
          "name": this.step2,
          "color": this.c_color2,
          "bar_color": this.bar_color2,
          "current_status": this.current_status2

        },
        {

          "percent": this.prgrsBar3,
          "name": this.step3,
          "color": this.c_color3,
          "bar_color": this.bar_color3,
          "current_status": this.current_status3
        }
      ]
    }
  }

  subMqtt() {
    let currentStoreId = localStorage.getItem("currentStore")
    this.mqtSub = this.mqttService.observe(`/order_status/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).subscribe((message: IMqttMessage) => {
        const response = JSON.parse(message.payload.toString());
        if (response) {
          if (this.orderWithPayment.bot_order.id == response.bot_order.id) {
            this.orderWithPayment = Object.assign(new OrdersWithPayment(), response, {
              bot_order: Object.assign(new BotOrder(), response.bot_order, {
                occasion_schedule: moment(response.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
                created_at: moment(response.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
                updated_at: moment(response.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
                submitted_at: moment(response.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
              }),
              store: Object.assign(new Store(), response.store),
              items: response.items.map(o => Object.assign(new Order(), o, {
                modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
              })),
              payment: OrderHelpers.parsePayment(response.payment)
            });
            this.orderTrackingStatus(response);
          }
        }
      });
  }

  getOrderStatus() {
    this.orderService.getOrder(this.orderHash, "0").pipe(takeUntil(this.destroySubject)).subscribe((response: any) => {
      if (this.orderWithPayment.bot_order.id == response.bot_order.id) {
        this.orderWithPayment = Object.assign(new OrdersWithPayment(), response, {
          bot_order: Object.assign(new BotOrder(), response.bot_order, {
            occasion_schedule: moment(response.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
            created_at: moment(response.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
            updated_at: moment(response.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
            submitted_at: moment(response.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
          }),
          store: Object.assign(new Store(), response.store),
          items: response.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
          })),
          payment: OrderHelpers.parsePayment(response.payment)
        });
        this.orderTrackingStatus(response);
        this.cdr.markForCheck();
      }
    });
  }

  calculateTimeDifference(submitted_at: string, occasion_schedule: string): string {
    const submittedDate = new Date(submitted_at);
    const occasionDate = new Date(occasion_schedule);
    const diffMs = occasionDate.getTime() - submittedDate.getTime();
    // If time has passed, return "0 min"
    if (diffMs <= 0) {
      return "0 min";
    }
    // Convert to total minutes
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    // Build formatted string
    let parts: string[] = [];
    if (hours > 0) {
      parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
    }
    return parts.length > 1
      ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1]
      : parts[0];
  }

  ngOnDestroy() {
    if (this.mqtSub) {
      this.mqtSub.unsubscribe();
    }
    if (this.statusinterval) {
      clearInterval(this.statusinterval);
    }
    if (this.deliveryTrackSub) {
      this.deliveryTrackSub.unsubscribe();
    }
    this.destroySubject.next();
  }

}
